import './GoldBadge.scss';

export function GoldBadge(props) {
    return <span className={(props.className ?? '') + " GoldBadge"} style={props.style}>
        {props.children}
    </span>
}
